export const LOAD_HOMEPAGE_DATA_SUCCESS = "LOAD_HOMEPAGE_DATA_SUCCESS"
export const LOAD_HOMEPAGE_DATA = "LOAD_HOMEPAGE_DATA"
export const LOAD_HOMEPAGE_DATA_ERROR = "LOAD_HOMEPAGE_DATA_ERROR"
export const CHANGE_SEARCH_TEXT = "CHANGE_SEARCH_TEXT"
export const LOAD_SEARCH_DATA = "LOAD_SEARCH_DATA"
export const LOAD_SEARCH_DATA_SUCCESS = "LOAD_SEARCH_DATA_SUCCESS"
export const PURCHASE_PRODUCT = "PURCHASE_PRODUCT"
export const WISHLIST_PRODUCT = "WISHLIST_PRODUCT"
